import React from 'react';
const DataContext = React.createContext({}); // данные передаем в ApiData
export default DataContext;
